export const LOCKS_VIEW_PREFERENCE_KEY = "locks:view:preference";

export const LOCKS_VIEW = {
  LEGACY: "legacy",
  NEW: "new",
} as const;

export type LocksViewPreference =
  (typeof LOCKS_VIEW)[keyof typeof LOCKS_VIEW];

const DEFAULT_LOCKS_VIEW: LocksViewPreference = LOCKS_VIEW.NEW;

export const getLocksViewPreference = (
  isSuperUser = true,
): LocksViewPreference => {
  const preference = localStorage.getItem(LOCKS_VIEW_PREFERENCE_KEY);

  if (preference === LOCKS_VIEW.LEGACY || preference === LOCKS_VIEW.NEW) {
    return preference;
  }

  return isSuperUser ? DEFAULT_LOCKS_VIEW : LOCKS_VIEW.LEGACY;
};

export const setLocksViewPreference = (value: LocksViewPreference): void => {
  localStorage.setItem(LOCKS_VIEW_PREFERENCE_KEY, value);
};

export const getLocksViewPath = (
  value?: LocksViewPreference,
  isSuperUser = true,
): string => {
  const preference = value ?? getLocksViewPreference(isSuperUser);
  return preference === LOCKS_VIEW.LEGACY
    ? "/admin/locks-legacy"
    : "/admin/locks";
};
